import React, {Component} from 'react';
import {matchPath} from 'react-router';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';

import classes from './table_row.css';

class TableRow extends Component {

    render () {

        let rowClasses = "flex items-center text-gray-800 rounded-sm py-2 px-4";
        if (this.props.clickEvent) {
            rowClasses += " cursor-pointer hover:bg-gray-100 active:bg-gray-200";
        } else {
            rowClasses += " cursor-default";
        }
        if (this.props.selected) {
            rowClasses = "flex items-center cursor-default text-white bg-blue-400 rounded-sm py-2 px-4";
        }

        let betaTag = null;
        if (this.props.beta) {
            betaTag = (
                <span className="bg-purple-400 text-white px-2 text-xs rounded-sm ml-2 shrink-0">BETA</span>
            );
        }

        let iconTag = null;
        if (this.props.icon) {
            iconTag = (
                <img className="h-6 w-6 bg-blue-500 rounded-sm mr-3 shrink-0 object-cover" src={this.props.icon} />
            );
        }

        let label;
        if (this.props.detail_text) {
            label = (
                <div className="min-w-0 flex-1">
                    <p className="text-base font-medium truncate">{this.props.text}</p>
                    <p className={"text-sm truncate " + (this.props.selected ? "text-blue-100" : "text-gray-400")}>{this.props.detail_text}</p>
                </div>
            );
        } else {
            label = (
                <p className="text-base truncate min-w-0 flex-1">{this.props.text}</p>
            );
        }

        let badge = null;
        if (this.props.badge_count > 0) {
            badge = (
                <span className="ml-2 shrink-0 inline-block py-0.5 px-2 text-xs text-white leading-4 font-medium rounded-full bg-red-500">
                    {this.props.badge_count}
                </span>
            );
        }

        let action = () => {
            if (this.props.clickEvent) {
                this.props.clickEvent();
            }
        }

        return (
            <div className={rowClasses} onClick={action}>
                {iconTag}
                {label}
                {betaTag}
                {badge}
            </div>
        );
    }
}

export default TableRow;
